import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "../Components/Layout";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import MyWeeklyReport from "../Components/timesheet/MyWeeklyReport";

const MyAttendancePage = () => {
  const [date, setDate] = useState("");
  const [currentUser, setCurrentUser] = useState("John Doe"); // Replace with actual logged-in user's name
  const [punchSuccess, setPunchSuccess] = useState(false);
  const [punchError, setPunchError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [reportKey, setReportKey] = useState(0); // Key for MyWeeklyReport

  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDate(today);
    setDate(formattedDate);
  }, []);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const weekday = date.toLocaleString("en-US", { weekday: "short" });
    return `${weekday}, ${day} ${month} ${year}`;
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve(`Lat: ${latitude}, Long: ${longitude}`);
        },
        (error) => reject("Location not available")
      );
    });
  };

  // const getIPLocation = async () => {
  //   try {
  //     const response = await fetch("https://get.geojs.io/v1/ip/geo.json");
  //     const data = await response.json();
  //     console.log("IP Location:", data);
  //     return data;
  //   } catch (error) {
  //     console.error("Failed to fetch IP location:", error);
  //   }
  // };
  
  
  const handlePunchInTime = async () => {
    console.log("========== Punch Started");

    
    try {
      const location = await getCurrentLocation();
      //const IPLocation = await getIPLocation()
      // const location = `Lat: ${IPLocation.latitude}, Long: ${IPLocation.longitude}`
      //console.log(IPLocation);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/attendance/punch-in?loginLocation=${location}`,
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.ok) {
        setPunchSuccess(true);
        setErrorMessage("Punch In successful");
        setTimeout(() => setPunchSuccess(false), 5000); // Hide success after 5 seconds
        setReportKey((prevKey) => prevKey + 1); // Reload MyWeeklyReport
      } else {
        setPunchError(true);
        setErrorMessage("Error during Punch In");
        setTimeout(() => setPunchError(false), 5000); // Hide error after 5 seconds
      }
    } catch (error) {
      console.error("Error punching in:", error);
      setPunchError(true);
      setErrorMessage("Punch In failed. Please try again.");
      setTimeout(() => setPunchError(false), 5000);
    }
  };

  const handlePunchOutTime = async () => {
    try {
      const location = await getCurrentLocation();
      // const IPLocation = await getIPLocation()
      // const location = `Lat: ${IPLocation.latitude}, Long: ${IPLocation.longitude}`
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/attendance/punch-out?logoutLocation=${location}`,
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.ok) {
        setPunchSuccess(true);
        setErrorMessage("Punch Out successful");
        setTimeout(() => setPunchSuccess(false), 5000); // Hide success after 5 seconds
        setReportKey((prevKey) => prevKey + 1); // Reload MyWeeklyReport
      } else {
        setPunchError(true);
        setErrorMessage("Error during Punch Out");
        setTimeout(() => setPunchError(false), 5000); // Hide error after 5 seconds
      }
    } catch (error) {
      console.error("Error punching out:", error);
      setPunchError(true);
      setErrorMessage("Punch Out failed. Please try again.");
      setTimeout(() => setPunchError(false), 5000);
    }
  };

  return (
    <Layout>
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>My Weekly Attendance</h2>
          <div>
            <button
              className="btn btn-success m-1"
              onClick={punchSuccess ? undefined : handlePunchInTime}
              disabled={punchSuccess}
              title={punchSuccess ? "Already Punched In" : ""}
            >
              Punch In
            </button>
            <button
              className="btn btn-success"
              onClick={punchSuccess ? undefined : handlePunchOutTime}
              disabled={punchSuccess}
              title={punchSuccess ? "Already Punched Out" : ""}
            >
              Punch Out
            </button>
          </div>
        </div>

        {punchSuccess && (
          <div
            className="alert alert-success alert-dismissible fade show"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => setPunchSuccess(false)}
            ></button>
          </div>
        )}

        {punchError && (
          <div
            className="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => setPunchError(false)}
            ></button>
          </div>
        )}

        <MyWeeklyReport key={reportKey} />
      </div>
    </Layout>
  );
};

export default MyAttendancePage;
